import { documents } from 'api';
import { UPLOAD_DOCUMENT, DELETE_DOCUMENT, VALIDATE_DOCUMENT } from 'store/actions/documents';

export default {
  [UPLOAD_DOCUMENT]: (params, { container, folder, docType, file }) =>
    new Promise((resolve, reject) => {
      documents
        .uploadDocument({ container, folder, docType, file })
        .then(
          ({ data }) => {
            resolve(data);
          },
          err => {
            reject(err);
          }
        )
        .catch();
    }),

  [DELETE_DOCUMENT]: (params, { container, folder, fileName }) =>
    new Promise((resolve, reject) => {
      documents
        .deleteDocument({ container, folder, fileName })
        .then(
          ({ data }) => {
            resolve(data);
          },
          err => {
            reject(err);
          }
        )
        .catch();
    }),

  [VALIDATE_DOCUMENT]: (params, data) =>
    new Promise((resolve, reject) => {
      documents.validateDocument(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    })
};
